export default __webpack_public_path__ + "static/media/KPI-2.187553ad.jpg";